import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LotesService } from '../../services/lotes.service';
import { ProductionOrderService } from '../../services/productionOrders.service';
import { ProductsService } from '../../services/products.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { FilterUrlService } from '../../services/filter-url.service';

@Component({
  selector: 'desconche',
  templateUrl: './desconche.component.html',
  styleUrls: ['./desconche.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DesconcheComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public lotes:any[];
  public signupForm:FormGroup;
  public products:any[];
  public trabajadores:any[];
  public pesajes:any[];
  public ultimotrabajador:string;
  public ultimopeso:number;
  public ultimahora:Date;
  public ultimopesototal:number;
  public ultimonumeropesadas:number;

  constructor(private _productsService:ProductsService,private _lotesService:LotesService,private _productionorderService:ProductionOrderService,private _localeService: BsLocaleService,private _loaddata: LoadService,private _filter: FilterUrlService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.pesajes = [];
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._localeService.use('es');

    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl(null,Validators.required),
      'peso': new FormControl(null,Validators.required),
      'fecha': new FormControl(null,Validators.required),
      'proceso': new FormControl(null,Validators.required),
      'producto': new FormControl(null,Validators.required),
      'pesajes':new FormControl(0),
      'trabajador':new FormControl(null,Validators.required)
    });

    this.loadProducts();
  }

  loadProducts(){
    this.products = [];
    this.isopen = true;
    this.alert = "Cargando listado de productos.";
    this._loaddata.loadChange(20);

    this.products = [{id:1,tipo:'Media Concha'},{id:2,tipo:'Carne'}];
    this.loadWorkers();
  }

  loadWorkers(){
    this.ultimotrabajador = '';
    this.ultimopeso = 0;
    this.trabajadores = [];
    this.ultimopesototal = 0;
    this.ultimonumeropesadas= 0;

    this.isopen = true;
    this.alert = "Cargando listado de trabajadores.";
    this._loaddata.loadChange(40);

    this.trabajadores.push({'codigo':1,'name':'Javier Riquelme'});
    this.trabajadores.push({'codigo':2,'name':'Jose Flores'});
    this.trabajadores.push({'codigo':3,'name':'Nancy Allendes'});

    this.loadData();
  }

/**
 * Carga el listado de informacion.
 */
  loadData():void{
    this.pesajes = [];
    this.lotes = [];
    this.alert="Cargando listado de procesos / lotes.";
    this.isopen = true;
    this._loaddata.loadChange(60);
    this.cleanForm();

    this._lotesService.getAll().subscribe(
      (response:any) => {
        this.lotes = response.data;
        this._loaddata.loadChange(100);
        this.alert = "Carga correcta."

        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  onLoadWorker(){
    this.ultimotrabajador = '';
    this.ultimopeso = 0;
    this.ultimopesototal = 0;
    this.ultimonumeropesadas = 0;

    for(let tra of this.trabajadores){
      if(parseInt(tra.codigo) == parseInt(this.signupForm.get('trabajador').value)){
        this.ultimotrabajador = tra.name;
      }
    }
  }

  onLoadWeight(){
    this.ultimopesototal = 0;
    this.ultimonumeropesadas = 0;
    this.ultimopeso = this.signupForm.get('peso').value;
    this.ultimahora = new Date();
    this.pesajes.push({nombre:this.ultimotrabajador,codigo:this.signupForm.get('trabajador').value,peso:this.ultimopeso,fecha:this.ultimahora});

    for(let pesa of this.pesajes){
      if(pesa.codigo == this.signupForm.get('trabajador').value){
        this.ultimonumeropesadas += 1;
        this.ultimopesototal += pesa.peso;
      }
    }

    this.cleanForm();
  }

  onBlock(op:number){
    if(op == 1){
      this.signupForm.get('proceso').disable();
    }
    else if (op == 2){
      this.signupForm.get('producto').disable();
    }
    else if (op == 3){
      this.signupForm.get('fecha').disable();
    }
  }

/**
 * Cierra el modal
 */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

/**
 * Cierra el mensaje de alerta.
 */
  onClosed(): void {
    this.isopen = false;
  }

/**
 * Muestra un error
 * @param  msg mensaje del error
 */
 showError(msg:string){
   if(msg == undefined){
     this.alert = 'No tiene permisos para realizar la acción.';
   }
   else{
     this.alert = msg;
   }
   this._loaddata.loadChange(100);
   this.isopen =true;
 }

/**
 * Limpia el formulario para volver a utilizarlo despues.
 */
  cleanForm():void{

    this.signupForm.patchValue({
      'id': '',
      'peso':'',
      'pesajes':'',
      'trabajador':''
    });
    // this.signupForm = new FormGroup({
    //   'id': new FormControl(null,Validators.required),
    //   'peso': new FormControl(null,Validators.required),
    //   'fecha': new FormControl(null,Validators.required),
    //   'proceso': new FormControl(null,Validators.required),
    //   'producto': new FormControl(null,Validators.required),
    //   'pesajes':new FormControl(0),
    //   'trabajador':new FormControl(null,Validators.required)
    // });
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/desconche/desconche.component.ts